import React, { useEffect, useState, createContext, useContext } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import {allRoutesWeb} from "./allRoutesWeb";

// Создаём контекст
const ReferralContext = createContext<string>("newID");

export const useReferral = () => useContext(ReferralContext);

function ReferralProvider({ children }: { children: React.ReactNode }) {
    const [referralId, setReferralId] = useState("newID");
    const location = useLocation();

    useEffect(() => {
        let pathName = location.pathname;

        if (pathName.length >= 30) {
            let newPathName = pathName.slice(1);
            localStorage.setItem("ref", newPathName);
            setReferralId(newPathName);
        } else {
            let storedRef = localStorage.getItem("ref");
            if (storedRef && storedRef.length >= 30 && pathName !== storedRef) {
                setReferralId(storedRef);
            }
        }
    }, [location.pathname]);

    return (
        <ReferralContext.Provider value={referralId}>
            {children}
        </ReferralContext.Provider>
    );
}

function IndexRouteWeb({ address, chainId, isConnected, status, open, provider }: any) {
    return (
        <ReferralProvider>
            <Routes>
                {allRoutesWeb.map((route, index) => (
                    <Route
                        path={route.path}
                        element={
                            <route.component
                                address={address}
                                chainId={chainId}
                                isConnected={isConnected}
                                open={open}
                                status={status}
                                provider={provider}
                            />
                        }
                        key={index}
                    />
                ))}
            </Routes>
        </ReferralProvider>
    );
}

export default IndexRouteWeb;
